import React from 'react';
import Tilt from 'react-parallax-tilt';
import styled from 'styled-components';

import { GiftCardSVG } from 'components/settings/referrals/GiftCardSVG';
import { TicketSVG } from 'components/settings/referrals/TicketSVG';

const StyledTilt = styled(Tilt)`
  width: 100%;
`;

type Props = {
  className?: string;
  variant: 'ticket' | 'giftCard';
};

export const Promo = ({ className, variant }: Props) => (
  <StyledTilt className={className} tiltMaxAngleX={8} tiltMaxAngleY={8}>
    {variant === 'giftCard' ? <GiftCardSVG /> : <TicketSVG />}
  </StyledTilt>
);
